import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Spinner, Alert, Breadcrumb } from 'react-bootstrap';
import { Link, useParams } from 'react-router-dom';
import axiosInstance from '../utils/axiosConfig';
import ProductCard from '../components/ProductCard';

const CategoryPage = () => {
  const { id } = useParams();
  const [category, setCategory] = useState(null);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCategoryProducts = async () => {
      try {
        setLoading(true);
        const { data } = await axiosInstance.get(`/categories/${id}/products`);
        setCategory(data.category);
        setProducts(data.products);
        setLoading(false);
      } catch (err) {
        console.error('Failed to fetch category products', err);
        setError('Failed to load products. Please try again later.');
        setLoading(false);
      }
    };

    fetchCategoryProducts();
  }, [id]);

  if (loading) {
    return (
      <Container className="d-flex justify-content-center mt-5">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </Container>
    );
  }

  if (error) {
    return (
      <Container className="mt-5">
        <Alert variant="danger">{error}</Alert>
      </Container>
    );
  }

  if (!category) {
    return (
      <Container className="mt-5">
        <Alert variant="warning">Category not found</Alert>
      </Container>
    );
  }

  return (
    <Container className="py-5">
      <Breadcrumb className="mb-4">
        <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>Home</Breadcrumb.Item>
        <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/categories" }}>Categories</Breadcrumb.Item>
        <Breadcrumb.Item active>{category.name}</Breadcrumb.Item>
      </Breadcrumb>

      <div className="mb-5">
        <h1 className="mb-3">{category.name}</h1>
        {category.description && <p className="lead">{category.description}</p>}
      </div>

      {products.length === 0 ? (
        <Alert variant="info">No products found in this category</Alert>
      ) : (
        <Row>
          {products.map(product => (
            <Col key={product.id} sm={6} md={4} lg={3} className="mb-4">
              <ProductCard product={product} />
            </Col>
          ))}
        </Row>
      )}
    </Container>
  );
};

export default CategoryPage; 